export default __webpack_public_path__ + "static/media/prosper-health-advocacy.3d182d20.svg";